// src/lib/api/shared/errors.js

export class ApiError extends Error {
  constructor(message, code = null, originalError = null) {
    super(message)
    this.name = 'ApiError'
    this.code = code
    this.originalError = originalError
    this.timestamp = new Date().toISOString()
  }
}

export const handleApiError = (error, operation, entityType = null) => {
  console.error(`[API Error] ${operation}${entityType ? ` for ${entityType}` : ''}:`, error)
  
  // Supabase specific error handling
  if (error.code === 'PGRST116') {
    return new ApiError('No records found', 'NOT_FOUND', error)
  }
  
  if (error.code === 'PGRST301') {
    return new ApiError('Authentication required', 'AUTH_REQUIRED', error)
  }
  
  if (error.message?.includes('company_id')) {
    return new ApiError('Company access denied', 'COMPANY_ACCESS_DENIED', error)
  }
  
  if (error.message?.includes('permission denied')) {
    return new ApiError('Permission denied', 'PERMISSION_DENIED', error)
  }

  if (error.code === 'PERMISSION_DENIED' || error.message?.includes('PERMISSION_DENIED')) {
    return new ApiError("You don't have permission to perform this action", 'PERMISSION_DENIED', error)
  }

  if (error.status === 403 || error.statusCode === 403) {
    return new ApiError(error.message || 'Permission denied', 'PERMISSION_DENIED', error)
  }

  if (error.message?.includes('Employee slot limit reached')) {
    return new ApiError('Employee slot limit reached. Please purchase additional slots.', 'EMPLOYEE_SLOT_LIMIT_REACHED', error)
  }
  
  if (error.message?.includes('duplicate key')) {
    return new ApiError('Record already exists', 'DUPLICATE_KEY', error)
  }
  
  if (error.message?.includes('foreign key')) {
    return new ApiError('Referenced record not found', 'FOREIGN_KEY_VIOLATION', error)
  }
  
  return new ApiError(
    error.message || `Failed to ${operation}`,
    error.code || 'UNKNOWN_ERROR',
    error
  )
}

export const withErrorHandling = (fn, operation, entityType = null) => {
  return async (...args) => {
    try {
      return await fn(...args)
    } catch (error) {
      throw handleApiError(error, operation, entityType)
    }
  }
}

export const createErrorResponse = (message, code = null, details = null) => {
  return {
    data: [],
    error: {
      message,
      code,
      details,
      timestamp: new Date().toISOString()
    }
  }
}

export const createSuccessResponse = (data) => {
  return {
    data: Array.isArray(data) ? data : [data],
    error: null
  }
}